import { Component, OnInit, ViewChild } from '@angular/core';
import { ShellUpdateService, ShellUpdateMessage, ShellActionMessage } from '../../../services/shell-update-service/shell-update.service';
import { AppConfigService } from '../../../services/app-config-service/app-config.service';
import { Router } from '@angular/router';
import { TrustAddressModel } from '../../../models/trust-address';
import { TrustDataService } from '../../../services/trust-data-service/trust-data.service';
import { TrustScheduleModel } from '../../../models/trust-schedule-model';
import { MatSnackBar } from '@angular/material';
import { NgForm, NgControl, FormControl } from '@angular/forms';
import { HttpErrorResponse } from '../../../../../node_modules/@angular/common/http';
import { UserSessionService } from '../../../services/user-session-service/user-session.service';
import { LoggingService } from '../../../services/logging-service/logging.service';
import { DataQuality } from '../../../models/data-quality';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-portal-contact-admin',
  templateUrl: './portal-contact-admin.component.html',
  styleUrls: ['./portal-contact-admin.component.css']
})

export class PortalContactAdminComponent implements OnInit {
  @ViewChild(NgForm) form;
  @ViewChild('dataQualityForm') dataQualityForm: NgForm;

  private trustAddressList: TrustAddressModel[];
  private trustScheduleList: TrustScheduleModel[] = new Array<TrustScheduleModel>();
  private editingSchedule: TrustScheduleModel;
  private creatingSchedule: TrustScheduleModel;
  private addressLoaded: boolean = false;
  private newTrustAddressModel: TrustAddressModel = new TrustAddressModel();
  dataQuality: DataQuality = new DataQuality();
  dataQualityUndo: DataQuality = new DataQuality();
  loaded: boolean;
  error: boolean;
  adding: boolean;
  dataQualityAdding: boolean;
  dataQualityUpdating: boolean;


  constructor(private shellUpdateService: ShellUpdateService,
    private appConfigService: AppConfigService, private trustDataService: TrustDataService,
    private router: Router, private snackBar: MatSnackBar, private userSession: UserSessionService,
    private loggingService: LoggingService) { }

  ngOnInit() {
    // Make sure the route being accessed is desirable (not user from admin, or admin from user. Redirect if required)
    this.userSession.checkRoute(this.router.url);
    this.shellUpdateService.sendShellUpdateMessage(new ShellUpdateMessage(
      this.appConfigService.ApplicationName, 'Contact Information', null, null));

    this.dataQuality.ContactEmailAddress = '';
    this.dataQuality.ContactTelephoneNumber = '';

    this.shellUpdateService.sendShellUpdateActionMessage(new ShellActionMessage(false, false, true, false, true));
    this.getTrustData();
  }

  addedAddress() {
    this.trustAddressList.push(this.newTrustAddressModel);
    this.trustAddressList = this.trustAddressList.sort((a, b) => this.compare(a, b));
  }

  compare(a: TrustAddressModel, b: TrustAddressModel) {
    if (a.Label < b.Label) {
      return -1;
    }
    if (a.Label > b.Label) {
      return 1;
    }
    return 0;
  }

  private getTrustData() {
    this.loggingService.log('Loading trust data', this.appConfigService.LogToConsole);
    this.trustDataService.getTrustAddresses().subscribe(response => {
      this.trustAddressList = response.json();
      this.loggingService.log('Loaded trust address', this.appConfigService.LogToConsole);
      this.trustDataService.getTrustSchedules().subscribe(result => {
        this.trustScheduleList = result.json();
        this.loggingService.log('Loaded trust schedules', this.appConfigService.LogToConsole);
        this.trustDataService.getTrustDataQualityContact()
          .pipe(map(contactResponse => contactResponse.json()))
          .subscribe(dataQualityResponse => {
            this.dataQuality = dataQualityResponse;
            this.dataQualityUndo = Object.assign(this.dataQualityUndo, this.dataQuality);
            this.loggingService.log('Loaded data quality information', this.appConfigService.LogToConsole);
            this.loaded = true;
          });
      }, (error: HttpErrorResponse) => {
        this.handleError(error);
      });
    }, (error: HttpErrorResponse) => {
      this.handleError(error);
    });
  }

  clearEmailAddress(control: FormControl) {
    control.reset();
  }

  addNewAddress() {
    this.adding = true;
    this.newTrustAddressModel = new TrustAddressModel();
  }

  addDataQuality($event: MouseEvent) {
    this.dataQualityAdding = true;
    this.dataQualityUndo = Object.assign(this.dataQualityUndo, this.dataQuality);
  }

  undoDataQuality($event: MouseEvent) {
    this.dataQuality = Object.assign(this.dataQuality, this.dataQualityUndo);
    this.dataQualityAdding = false;
  }

  saveDataQuality() {
    this.dataQualityUpdating = true;
    this.trustDataService.updateTrustDataQualityContact(this.dataQuality)
      .subscribe(response => {
        this.dataQualityUpdating = false;
        this.dataQualityAdding = false;
        this.snackBar.open('Data Quality contact details updated successfully', '', { duration: 5000 });
      }, error => {
        this.handleError(error);
      });
  }

  cancelAddDataQuality(form: NgForm) {
    this.dataQuality = Object.assign(this.dataQuality, this.dataQualityUndo);
    this.dataQualityAdding = false;
  }

  cancel() {
    this.adding = false;
  }

  // Handles any potential http errors
  handleError(error: HttpErrorResponse) {
    switch (error.status) {
      case 0:
        this.error = true;
        this.snackBar.open('Sorry, we can\'t do that. You appear to be offline.', '', { duration: 5000 });
        this.loggingService.log('Error - offline', this.appConfigService.LogToConsole);
        break;
      case 401:
        this.error = true;
        this.snackBar.open('Sorry, we can\'t do that. Your login has expired.', '', { duration: 5000 });
        this.loggingService.log('Error - login expired', this.appConfigService.LogToConsole);
        this.userSession.logout();
        break;
      case 500:
        this.error = true;
        this.snackBar.open('Sorry, we can\'t do that. Server error.', '', { duration: 5000 });
        this.loggingService.log('Error - Server error', this.appConfigService.LogToConsole);
        break;
    }
  }

  createNewSchedule(event: Event) {
    event.stopPropagation();
    const newSchedule: TrustScheduleModel = new TrustScheduleModel();
    newSchedule.IsValid = false;
    newSchedule.ShowEdit = false;
    this.creatingSchedule = newSchedule;
  }

  getAmPm(value: any) {
    switch (value) {
      case '0':
        return 'am';
      case '1':
        return 'pm';
      default:
        break;
    }
  }

  getDay(value: any) {
    switch (value) {
      case '1':
        return 'Mon';
      case '2':
        return 'Tue';
      case '3':
        return 'Wed';
      case '4':
        return 'Thr';
      case '5':
        return 'Fri';
      case '6':
        return 'Sat';
      case '7':
        return 'Sun';

      default:
        break;
    }
  }

  editStart(event: Event, schedule: TrustScheduleModel) {
    event.stopPropagation();

    if (this.editingSchedule) {
      this.editingSchedule.ShowEdit = false;
    }

    schedule.ShowEdit = true;
    this.editingSchedule = schedule;
  }

  editFinish(event: Event) {
    event.stopPropagation();

    if (this.creatingSchedule == undefined && this.editingSchedule == undefined) {
      return;
    }

    if (this.creatingSchedule) {
      this.creatingSchedule = null;
      return;
    }

    if (this.editingSchedule.ShowEdit == false) {
      return;
    }

    if (!this.form.valid && (this.form.touched || this.form.dirty)) {
      this.snackBar.open('Schedule has some errors. Please check and try again', '', { duration: 5000 });
      return;
    }

    this.loaded = false;
    this.loggingService.log('Updating schedule', this.appConfigService.LogToConsole);
    this.trustDataService.updateSchedule(this.editingSchedule).subscribe(response => {
      this.loggingService.log('Schedule updated', this.appConfigService.LogToConsole);

      this.snackBar.open('Schedule updated', '', { duration: 5000 });
      this.loaded = true;
    }, (error: HttpErrorResponse) => {
      this.handleError(error);
    });

    this.editingSchedule.ShowEdit = false;
  }

  disableProp(event: Event) {
    event.stopPropagation();
  }

  cancelBubble(event: Event) {
    event.stopPropagation();
  }

  deleteSchedule(event: Event, trustScheduleModel: TrustScheduleModel) {
    this.loaded = false;
    this.loggingService.log('Deleting schedule', this.appConfigService.LogToConsole);

    this.trustDataService.deleteSchedule(trustScheduleModel).subscribe(response => {
      this.snackBar.open('Schedule deleted', '', { duration: 5000 });
      this.loggingService.log('Schedule deleted', this.appConfigService.LogToConsole);

      this.trustDataService.getTrustSchedules().subscribe(result => {
        this.trustScheduleList = result.json();
        this.loaded = true;
      }, (error: HttpErrorResponse) => {
        this.handleError(error);
      });
    }, (error: HttpErrorResponse) => {
      this.handleError(error);
    });
  }

  updateAddress() {
    // this.trustDataService.updateTrustAddress(this.trustAddressModel).subscribe(reponse => {
    //   this.snackBar.open('Address updated', '', { duration: 5000 });
    //   this.trustDataService.getTrustAddresses().subscribe(response => {
    //     this.addressList = response.json();
    //     this.adding = false;
    //   }, (error: HttpErrorResponse) => {
    //     this.handleError(error);
    //   });
    // });

  }

  addSchedule(event: Event, schedule: TrustScheduleModel) {
    event.stopPropagation();
    this.trustDataService.addSchedule(schedule).subscribe(result => {
      this.snackBar.open('Schedule added', '', { duration: 5000 });
      this.creatingSchedule = null;
      this.trustDataService.getTrustSchedules().subscribe(result => {
        this.trustScheduleList = result.json();
      }, (error: HttpErrorResponse) => {
        this.handleError(error);
      });
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/views/portal-admin-contact/portal-contact-admin/portal-contact-admin.component.ts